import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import { toBcp47 } from '@/utils/helpers/language.helper';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const AppHelmet = () => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { i18n } = useTranslation();
  const bcp47Lang = toBcp47(i18n.language);

  return (
    <Helmet htmlAttributes={{ lang: bcp47Lang }}>
      <link rel="icon" href={currentAccount?.platformSettings?.favIcon} />
      <link
        rel="apple-touch-icon"
        href={currentAccount?.platformSettings?.favIcon}
      />
      <meta
        name="description"
        content={currentAccount?.platformSettings?.name}
      />
      <title>{currentAccount?.platformSettings?.name}</title>
    </Helmet>
  );
};
